import { useContext } from 'react'
import { UserContext } from '../../../contexts/user-context'
import { useAuth0 } from '@auth0/auth0-react'
import MenuItem from "../../ui/MenuItem"

const HeaderNavItems = () => {
    const { isAuthenticated } = useAuth0()
    const { userProfileCompleted, emailVerified } = useContext(UserContext)

    return userProfileCompleted && emailVerified && isAuthenticated ? (
        <>
            <MenuItem
                id="dashboard-link"
                label="Dashboard"
                className=""
                link="/dashboard"
            />
            <MenuItem
                id="transactions-menu"
                label="Transactions"
                className=""
                subMenu={transactionsSubMenu}
            />
            <MenuItem
                id="accounts-menu"
                label="Accounts"
                className=""
                subMenu={accountsSubMenu}
            />
            <MenuItem
                id="tools-menu"
                label="Tools"
                className=""
                subMenu={toolsSubMenu}
            />
            <MenuItem
                id="help-menu"
                label="Help"
                className=""
                subMenu={helpSubMenu}
            />
        </>
    ) : null
}

export default HeaderNavItems

const transactionsSubMenu = {
    items: [
        {
            label: 'My Transactions',
            link: '/transactions',
        },

        {
            label: 'My Exceptions',
            link: '/exceptions',
        },
        {
            label: 'Suggestions',
            link: '/transaction-suggestions',
        },
        {
            label: 'Add New',
            link: '/add-transaction',
        },
    ],
}

const accountsSubMenu = {
    items: [
        {
            label: 'My Accounts',
            link: '/accounts',
        },
        {
            label: 'Connect (OB)',
            link: '/accounts?connect=openbanking',
        },
        {
            label: 'Connect (Plaid)',
            link: '/accounts?connect=plaid',
        },
        {
            label: 'Plaid Integration',
            link: '/plaid-integration',
        },
        {
            label: 'Add New (Manual)',
            link: '/add-account',
        }
    ],
}

const toolsSubMenu = {
    items: [
        {
            label: 'Debt Snowball',
            link: '/tools/debt-snowball',
        },
        {
            label: 'Credit Card Payment Calculator',
            link: '/tools/credit-card-payment-calculator',
        },
        {
            label: 'Simple Payoff Calculator',
            link: '/tools/payoff-calculator',
        },
        {
            label: 'Refinance Calculator',
            link: '/tools/refinance-calculator',
        },
        {
            label: 'Paycheck Calculator',
            link: '/tools/paycheck-calculator',
        }
    ],
}

const helpSubMenu = {
    items: [
        {
            label: 'How to Get Started',
            link: '/help-center',
        },
        {
            label: 'Contact Support',
            link: '/support',
        },
    ],
}
